import { expVal } from '@atlassian/jira-feature-experiments';

const JiraTimelineAgentActivityColumnRelayProvider = {
	get(): boolean {
		return expVal('jira_timeline_agent_activity_column_fe', 'isEnabled', false);
	},
};

export default JiraTimelineAgentActivityColumnRelayProvider;
